export default "__VITE_ASSET__Bxp7JMUr__"